export enum GridNames {
  OrderHeaders = 'order-headers',
  OrderDuplicationHeaders = 'order-duplication-headers',
  WarrantyHeaders = 'warranty-headers',
  ReturnHeaders = 'return-headers',
  AccountingDocuments = 'accounting-documents',
  BackorderItems = 'backorder-items',
}
